import {UpdateSWStatusType} from '@/constants/dataEnum';
import * as updateSystemActionType from '@/constants/updateSystemActionType';

export const initialState = {
  InstallSystemUpdate: undefined,
  SystemUpdateStatus: undefined,
  CancelDownloadBinary: undefined,
  StatusDonloadBinaryUpdate: undefined,
  DownloadBinaryUpdate: undefined,
  CheckVersionSystem: undefined,
  ReleaseNotes: undefined,
  IsMinimizeUpdate: false,
  IsRestartLater: false,
  updateSWStatus: UpdateSWStatusType.IDLE,
};

export function updateSystemStore(state = initialState, action = {}) {
  switch (action.type) {
    case updateSystemActionType.STATUS_SYSTEM_UPDATE:
      return {
        ...state,
        SystemUpdateStatus: action.value,
        SystemUpdatePending: false,
      };

    case updateSystemActionType.INSTALL_SYSTEM_UPDATE:
      return {
        ...state,
        InstallSystemUpdate: action.value,
        SystemUpdatePending: false,
        SystemUpdateStatus: undefined,
        CancelDownloadBinary: undefined,
      };

    case updateSystemActionType.CANCEL_DOWNLOAD_BINARY_UPDATE:
      return {
        ...state,
        CancelDownloadBinary: action.value,
        SystemUpdatePending: false,
        InstallSystemUpdate: undefined,
        SystemUpdateStatus: undefined,
        StatusDonloadBinaryUpdate: undefined,
      };

    case updateSystemActionType.STATUS_DOWNLOAD_BINARY_UPDATE:
      return {
        ...state,
        StatusDonloadBinaryUpdate: action.value,
        SystemUpdatePending: false,
        DownloadBinaryUpdate: undefined,
        CancelDownloadBinary: undefined,
      };

    case updateSystemActionType.DOWNLOAD_BINARY_UPDATE:
      return {
        ...state,
        DownloadBinaryUpdate: action.value,
        SystemUpdatePending: false,
        StatusDonloadBinaryUpdate: undefined,
        CancelDownloadBinary: undefined,
      };

    case updateSystemActionType.CHECK_VERSION_SYSTEM:
      return {
        ...state,
        CheckVersionSystem: action.value,
        SystemUpdatePending: false,
      };

    case updateSystemActionType.SYSTEM_UPDATE_PENDING:
      return {
        ...state,
        SystemUpdatePending: true,
      };

    case updateSystemActionType.RELEASE_NOTES:
      return {
        ...state,
        ReleaseNotes: action.value,
        SystemUpdatePending: false,
      };

    case updateSystemActionType.IS_MINIMIZE_UPDATE:
      return {
        ...state,
        IsMinimizeUpdate: action.value,
      };
    case updateSystemActionType.IS_RESTART_LATER:
      return {
        ...state,
        IsRestartLater: action.value,
      };
    case updateSystemActionType.SET_UPDATE_SW_STATUS:
      return {
        ...state,
        updateSWStatus: action.value,
      };

    // todo : Add stop action
    default:
      return state;
  }
}

export const postInstallSystemUpdate = (state) => state.InstallSystemUpdate;
export const getSystemUpdateStatus = (state) => state.SystemUpdateStatus;
export const postCancleDownloadBinary = (state) => state.CancelDownloadBinary;
export const getStatusDownloadBinary = (state) => state.StatusDonloadBinaryUpdate;
export const postDownloadBinaryUpdate = (state) => state.DownloadBinaryUpdate;
export const getCheckVersion = (state) => state.CheckVersionSystem;
export const getSystemUpdatePending = (state) => state.SystemUpdatePending;
export const getReleaseNotes = (state) => state.ReleaseNotes;
